import {
  FormHelperText as MuiFormHelperText,
  FormHelperTextProps,
  useFormControl,
} from '@mui/material';
import { Box } from '../mui';
import { IconWarning } from '../Icons';

const FormHelperText = ({ error, children, ...props }: FormHelperTextProps) => {
  const formControl = useFormControl();
  const isError = error ?? formControl?.error;

  return (
    <MuiFormHelperText error={error} {...props}>
      {isError && children ? (
        <Box
          component='span'
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
        >
          <IconWarning sx={{ fontSize: '1.25rem', color: 'error.main' }} />
          {children}
        </Box>
      ) : (
        children
      )}
    </MuiFormHelperText>
  );
};

export default FormHelperText;
